// extracted by mini-css-extract-plugin
export default {"container":"Code_container__xVxO7","code":"Code_code__xYMJr","button":"Code_button__aona8"};